import { type CommandProperties, createCommand } from '@canvas/rovo-content-bridge-api';

/**
 * @see {@link OnShowContextMenuCommand}
 */
export type OnShowContextMenuCommandProperties = CommandProperties;

/**
 * Command that represents a signal to notify that a context menu is show
 */
export const OnShowContextMenuCommand = createCommand<
  OnShowContextMenuCommandProperties,
  void
>('on-show-context-menu-command');
